module.exports = __webpack_public_path__ + "img/logo-magento.d64c33eb.png";